// ActionButtons.jsx (minimal version that should work)
import { FaEye, FaEdit, FaDownload, FaExchangeAlt } from "react-icons/fa";

export default function ActionButtons({
  onView,
  onEdit,
  onDownload,
  onDiff,
}) {
  return (
    <div className="flex items-center gap-4 text-lg">
      {onView && (
        <button onClick={onView} title="View" className="text-purple-600 hover:text-purple-800">
          <FaEye />
        </button>
      )}

      {onDiff && (
        <button onClick={onDiff} title="Diff" className="text-teal-600 hover:text-teal-800">
          <FaExchangeAlt />
        </button>
      )}

      {onEdit && (
        <button onClick={onEdit} title="Edit" className="text-blue-600 hover:text-blue-800">
          <FaEdit />
        </button>
      )}

      {onDownload && (
        <button onClick={onDownload} title="Download" className="text-green-600 hover:text-green-800">
          <FaDownload />
        </button>
      )}
    </div>
  );
}